<script type="text/jsx" lang="jsx">
import BuyNow from './buy-now.vue';
import Add from './add.vue';
import planPropsMixin from '@/plans/mx/plan-props';
import { mapGetters } from 'vuex';
import { MIX_BUY_FLOW_UTILS } from '@/common/service/flow/utils';
import { planTypes } from '@/common/constants';

export default {
  mixins: [planPropsMixin],
  computed: {
    ...mapGetters(['mixBuyPlanType4FlowType']),
  },
  render() {
    const mixBuyPayload = [this.mixBuyPlanType4FlowType, planTypes.MASTER_CLASS];

    if (this.$context.is.add2cart) return <Add {...this.$attrs} />;
    if (this.$context.is.buyNow || this.$context.is.basic2pro) {
      return <BuyNow {...{...this.$props, ...this.$attrs }} />;
    }
    // MIX_BUY
    if (MIX_BUY_FLOW_UTILS.planIsAdd2Cart(...mixBuyPayload)) {
      return <Add {...this.$attrs} />;
    }

    return null;
  },
};
</script>
